import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoAutoCompleteMixin from './KendoAutoCompleteMixin'

export default {
    name: 'kendo-autocomplete',
    mixins: [ KendoAutoCompleteMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('input', [
            this.$slots['kendo-datasource']
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoAutoComplete/index.js